export default "__VITE_ASSET__B6M_Egij__"